var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIOsApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 4.5,
    fill: "black",
    stroke: "#DC2418"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 38H33M22 44H38C38.5304 44 39.0391 43.7893 39.4142 43.4142C39.7893 43.0391 40 42.5304 40 42V18C40 17.4696 39.7893 16.9609 39.4142 16.5858C39.0391 16.2107 38.5304 16 38 16H22C21.4696 16 20.9609 16.2107 20.5858 16.5858C20.2107 16.9609 20 17.4696 20 18V42C20 42.5304 20.2107 43.0391 20.5858 43.4142C20.9609 43.7893 21.4696 44 22 44Z",
    stroke: "#DC2418",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIOsApplication);
export default __webpack_public_path__ + "static/media/iOSApplication.f5d1a542818e5148e6913617e45acf6a.svg";
export { ForwardRef as ReactComponent };